import Rails from "@rails/ujs";
Rails.start();

import "../public/dp";
import "../public/referral-link-generator";
